import { Helmet } from 'react-helmet';
import Chart from 'chart.js/auto';
import { React, useEffect, useContext, useState } from 'react';
import * as menu from "../../assets/menus/menu.js";
import UserContext from '../../components/User_Context.js';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import { useTranslation } from 'react-i18next';

function Dashboard_Screen(params) {

    const { currentUser } = useContext(UserContext);
    const { t } = useTranslation('labels');

    // TURN BACK ON IF YOU WANT TO USE const aiplanDashboard() function
    // useEffect(() => {
    //     let myLineChartInstance;
    //     let chartInstances = []; // Array to store chart instances

    //     menu.write({ user: currentUser() });
    //     (async () => {

    //         //     menu.write({ user: currentUser() });

    //         if (process.env.REACT_APP_PROFILE.toLowerCase() === "aiplan") {
    //             function createPolarChart(chartId, labels, data, colors) {
    //                 const ctx = document.getElementById(chartId);
    //                 const newChart = new Chart(ctx, {
    //                     type: 'polarArea',
    //                     data: {
    //                         defaultFontFamily: 'Poppins',
    //                         labels: labels,
    //                         datasets: [{
    //                             data: data,
    //                             borderWidth: 2,
    //                             backgroundColor: colors
    //                         }]
    //                     },
    //                     options: {
    //                         responsive: true
    //                     }
    //                 });
    //                 chartInstances.push(newChart); // Add new chart instance to array
    //             }

    //             function createLineChart(chartId, labels, data) {
    //                 const ctx = document.getElementById(chartId);
    //                 myLineChartInstance = new Chart(ctx, {
    //                     type: 'line',
    //                     data: {
    //                         labels: labels,
    //                         datasets: [{
    //                             label: 'Percentuale',
    //                             data: data,
    //                             fill: false,
    //                             borderColor: 'rgba(75, 192, 192, 1)',
    //                             tension: 0.1
    //                         }]
    //                     },
    //                     options: {
    //                         responsive: true,
    //                         scales: {
    //                             y: {
    //                                 beginAtZero: true,
    //                                 ticks: {
    //                                     callback: function (value) {
    //                                         return value + '%';
    //                                     }
    //                                 }
    //                             }
    //                         }
    //                     }
    //                 });
    //                 chartInstances.push(myLineChartInstance); // Add line chart instance to array
    //             }




    //             //     // Dati per i tre grafici polar
    //             const labels = ['Sede', 'Cds', 'Cds Med', 'Dottorati', 'Dipartimenti'];
    //             const colors = [
    //                 "rgba(255, 159, 64, 0.8)",
    //                 "rgba(75, 192, 192, 0.8)",
    //                 "rgba(153, 102, 255, 0.8)",
    //                 "rgba(54, 162, 235, 0.8)",
    //                 "rgba(255, 99, 132, 0.8)"
    //             ];

    //             const data1 = [80, 25, 100, 70, 40];
    //             const data2 = [60, 80, 40, 55, 70];
    //             const data3 = [50, 40, 90, 30, 60];

    //             // Dati per il grafico line (anni e percentuali)
    //             const years = ['2019', '2020', '2021', '2022', '2023'];
    //             const dataOption1 = [25, 5, 35, 10, 56];  // Dati per Opzione 1
    //             const dataOption2 = [40, 35, 40, 20, 60];  // Dati per Opzione 2
    //             const dataOption3 = [20, 10, 45, 15, 55];  // Dati per Opzione 3
    //             const dataOption4 = [10, 30, 45, 77, 45];  // Dati per Opzione 4


    //             //     // Creazione dei grafici Polar
    //             createPolarChart('myChart1', labels, data1, colors);
    //             createPolarChart('myChart2', labels, data2, colors);
    //             createPolarChart('myChart3', labels, data3, colors);
    //             createPolarChart('myChart4', labels, data1, colors);
    //             createPolarChart('myChart5', labels, data3, colors);

    //             // Creazione iniziale del grafico Line
    //             createLineChart('myLineChart', years, dataOption1);

    //             //     // Funzione per aggiornare il grafico Line in base alla selezione
    //             document.getElementById('yearSelect').addEventListener('change', function (event) {
    //                 const selectedOption = event.target.value;
    //                 let newData;

    //                 //         // Determina i nuovi dati in base alla selezione
    //                 if (selectedOption === 'option1') {
    //                     newData = dataOption1;
    //                 } else if (selectedOption === 'option2') {
    //                     newData = dataOption2;
    //                 } else if (selectedOption === 'option3') {
    //                     newData = dataOption3;
    //                 }
    //                 else if (selectedOption === 'option4') {
    //                     newData = dataOption4;
    //                 }

    //                 // Aggiorna il grafico con i nuovi dati
    //                 myLineChartInstance.data.datasets[0].data = newData;
    //                 myLineChartInstance.update(); // Rende effettiva la modifica

    //             });
    //         }
    //     })();
    //     return () => {
    //         chartInstances.forEach(chart => chart.destroy());
    //     };
    // }, []);

    // REMOVE THIS IF YOU WANT TO USE const aiplanDashboard() function
        useEffect(() => {
            menu.write({ user: currentUser() });
        }, []);


    const darmDashboard = () => {
        return (
            <div class="container-fluid py-5">
                {/* Titolo principale */}
                <div class="row justify-content-center text-center mb-5">
                    <div class="col-xl-8">
                        <h2 class="fw-bold text-primary">{t('aiPlanIpc')}</h2>
                        <p class="fs-5 text-muted">
                            {t('platformDescription')}
                        </p>
                    </div>
                </div>

                {/* Sezione descrittiva + vantaggi allineati */}
                <div class="row g-4 justify-content-center">
                    {/* Card: Cosa fa AI PLAN */}
                    <div class="col-md-12">
                        <div class="card shadow rounded-4 border-0 h-100">
                            <div class="card-header bg-light border-0 rounded-top-4 text-center">
                                <h4 class="card-title fw-semibold text-dark">{t('whatDoesAiPlanDo')}</h4>
                            </div>
                            <div class="card-body text-dark fs-6 lh-lg">
                                <p>
                                    {t('aiPlanDescription1')}
                                </p>
                                <p>
                                    {t('aiPlanDescription2')}
                                </p>
                                <p>
                                    {t('aiPlanDescription3')}
                                </p>
                                <p>
                                    {t('aiPlanDescription4')}
                                </p>
                                <p>
                                    {t('aiPlanDescription5')}
                                </p>
                                <p class="mt-4">
                                    {t('aiPlanConclusion')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 3 card vantaggi */}
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-shield-check fs-1 text-primary mb-3"></i>
                            <h5 class="fw-bold">{t('operationalSecurity')}</h5>
                            <p class="text-muted">{t('operationalSecurityDesc')}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-bar-chart-line fs-1 text-success mb-3"></i>
                            <h5 class="fw-bold">{t('analysisAndReports')}</h5>
                            <p class="text-muted">{t('analysisAndReportsDesc')}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-file-earmark-text fs-1 text-warning mb-3"></i>
                            <h5 class="fw-bold">{t('digitalization')}</h5>
                            <p class="text-muted">{t('digitalizationDesc')}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const aiplanNewDashboard = () => {
        return (
            <div class="container-fluid py-5">
                {/* Titolo principale */}
                <div class="row justify-content-center text-center mb-5">
                    <div class="col-xl-8">
                        <h2 class="fw-bold text-primary">{t('aiPlanAva3Title')}</h2>
                        <p class="fs-5 text-muted">
                            {t('aiPlanAva3Description')}
                        </p>
                    </div>
                </div>

                {/* Sezione descrittiva + vantaggi allineati */}
                <div class="row g-4 justify-content-center">
                    {/* Card: Cosa fa AI PLAN */}
                    <div class="col-md-12">
                        <div class="card shadow rounded-4 border-0 h-100">
                            <div class="card-header bg-light border-0 rounded-top-4 text-center">
                                <h4 class="card-title fw-semibold text-dark">{t('whatDoesAiPlanDo')}</h4>
                            </div>
                            <div class="card-body text-dark fs-6 lh-lg">
                                <p>
                                    {t('aiPlanAva3Description1')}
                                </p>
                                <p>
                                    {t('aiPlanAva3Description2')}
                                </p>
                                <p>
                                    {t('aiPlanAva3Description3')}
                                </p>
                                {/* <p>
                                    {t('aiPlanDescription4')}
                                </p>
                                <p>
                                    {t('aiPlanDescription5')}
                                </p> */}
                                <p class="mt-4">
                                    {t('aiPlanAva3Conclusion')}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* 3 card vantaggi */}
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-shield-check fs-1 text-primary mb-3"></i>
                            <h5 class="fw-bold">{t('operationalSecurity')}</h5>
                            <p class="text-muted">{t('operationalSecurityDesc')}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-bar-chart-line fs-1 text-success mb-3"></i>
                            <h5 class="fw-bold">{t('analysisAndReports')}</h5>
                            <p class="text-muted">{t('analysisAndReportsDesc')}</p>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="p-4 border rounded shadow-sm h-100 text-center">
                            <i class="bi bi-file-earmark-text fs-1 text-warning mb-3"></i>
                            <h5 class="fw-bold">{t('digitalization')}</h5>
                            <p class="text-muted">{t('digitalizationDescAva3')}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const aiplanDashboard = () => {
        return (

            <>
                <Helmet>
                    <script src="https://cdn.jsdelivr.net/npm/chart.js"></script>

                </Helmet>
                <div class="page-titles">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="javascript:void(0)">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.125 6.375L8.5 1.41667L14.875 6.375V14.1667C14.875 14.5424 14.7257 14.9027 14.4601 15.1684C14.1944 15.4341 13.8341 15.5833 13.4583 15.5833H3.54167C3.16594 15.5833 2.80561 15.4341 2.53993 15.1684C2.27426 14.9027 2.125 14.5424 2.125 14.1667V6.375Z" stroke="#2C2C2C" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M6.375 15.5833V8.5H10.625V15.5833" stroke="#2C2C2C" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {t('home')} </a>
                        </li>
                        <li id="userProfileBreadcrumb" class="breadcrumb-item active"><a href="javascript:void(0)">{t('dashboard')}</a></li>
                    </ol>
                </div>

                <div class="container-fluid">


                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active" id="Requisiti-tab" data-bs-toggle="tab" data-bs-target="#Requisiti-tab-pane" type="button" role="tab" aria-controls="Requisiti-tab-pane" aria-selected="true">{t('requirements')}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="Indicatori-tab" data-bs-toggle="tab" data-bs-target="#Indicatori-tab-pane" type="button" role="tab" aria-controls="Indicatori-tab-pane" aria-selected="false">{t('indicators')}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="Attivita-tab" data-bs-toggle="tab" data-bs-target="#Attivita-tab-pane" type="button" role="tab" aria-controls="Attivita-tab-pane" aria-selected="false">{t('activities')}</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link" id="Efficacia-tab" data-bs-toggle="tab" data-bs-target="#Efficacia-tab-pane" type="button" role="tab" aria-controls="Efficacia-tab-pane" aria-selected="false">{t('effectiveness')}</button>
                        </li>
                    </ul>


                    <div class="tab-content bg-white border-start border-bottom border-end" id="myTabContent">
                        <div class="tab-pane fade show active" id="Requisiti-tab-pane" role="tabpanel" aria-labelledby="Requisiti-tab" tabIndex="0">
                            <div class="container-fluid">


                                <div class="col-12">
                                    <div class="row">

                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('coveragePercentage')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">
                                                    <canvas id="myChart1"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('evaluatedRequirementsPercentage')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">
                                                    <canvas id="myChart2"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('compliancePercentage')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">

                                                    <canvas id="myChart3"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="Indicatori-tab-pane" role="tabpanel" aria-labelledby="Indicatori-tab" tabIndex="0">

                            <div class="container-fluid">


                                <div class="col-12">
                                    <div class="row">

                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('coveragePercentage')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">
                                                    <canvas id="myChart4"></canvas>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('compliancePercentage')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">
                                                    <canvas id="myChart5"></canvas>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="col">
                                            <div class="card">
                                                <div class="card-header">
                                                    <h4 class="card-title">
                                                        {t('trend')}
                                                    </h4>
                                                </div>
                                                <div class="card-body">
                                                    <div class="form-floating">
                                                        <select class="form-select" id="yearSelect" aria-label="chart line" defaultValue="">
                                                            <option value="">{t('selectIndicator')}</option>
                                                            <option value="option1">Livello di copertura delle aule con il sistema wifi</option>
                                                            <option value="option2">Percentuale dei CFU conseguiti al I anno sui CFU da conseguire</option>
                                                            <option value="option3">Presenza di un sistema di rilevazione delle opinioni dei dottorati</option>
                                                            <option value="option4">Numero di attività di terza missione rispetto ai docenti di ruolo del Dipartimento</option>
                                                        </select>
                                                        <label htmlFor="floatingSelect">{t('indicator')}</label>
                                                    </div>

                                                    <canvas id="myLineChart"></canvas>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>
                            </div>




                        </div>
                        <div class="tab-pane fade" id="Attivita-tab-pane" role="tabpanel" aria-labelledby="Attivita-tab" tabIndex="0">

                            <div class="container-fluid">
                                <div class="d-flex justify-content-between align-items-center mb-4">


                                </div>
                                <div class="row row-cols-auto">
                                    <div class="col-xl-12">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="form-floating">
                                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" defaultValue="">
                                                                <option value="">{t('all')}</option>
                                                                <option value="1">Presidio di Qualità</option>
                                                                <option value="2">Nucleo di Valutazione</option>
                                                                <option value="3">Direzione Generale</option>
                                                                <option value="4">Ufficio Scuole di Specializzazione Area Sanitaria</option>
                                                                <option value="5">Ufficio Offerta Formativa dei Corsi di Studio</option>
                                                                <option value="7">Manager Didattici</option>
                                                                <option value="8">Ufficio Bilanci e Rapporto di Sostenibilità</option>
                                                                <option value="9">Ufficio Controllo di Gestione e Risk Management</option>
                                                            </select>
                                                            <label htmlFor="floatingSelect">{t('structure')}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="form-floating">
                                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" defaultValue="">
                                                                <option value="">{t('all')}</option>
                                                                <option value="1">Pianificazione</option>
                                                                <option value="2">Relazione</option>
                                                                <option value="3">Valutazione</option>
                                                                <option value="4">Report</option>
                                                                <option value="5">Bilancio</option>
                                                            </select>
                                                            <label htmlFor="floatingSelect">{t('category')}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="form-floating">
                                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" defaultValue="">
                                                                <option value="">{t('all')}</option>
                                                                <option value="1">Rendiconto</option>
                                                                <option value="2">Matrice</option>
                                                                <option value="3">Rapporto</option>
                                                                <option value="4">Estratto</option>

                                                            </select>
                                                            <label htmlFor="floatingSelect">{t('typology')}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col">
                                                        <div class="form-floating">
                                                            <select class="form-select" id="floatingSelect" aria-label="Floating label select example" defaultValue="">
                                                                <option value="">{t('all')}</option>
                                                                <option value="1">Elaborato</option>
                                                                <option value="2">Validato</option>
                                                                <option value="3">Approvato</option>
                                                            </select>
                                                            <label htmlFor="floatingSelect">{t('status')}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-grid gap-2 pt-2">
                                                    <button type="button" class="btn btn-success"><i class="me-2 fa-solid fa-magnifying-glass"></i>{t('search')}</button>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">

                                    <div class="col-xl-12">
                                        <div class="card">
                                            <div class="card-body p-0">
                                                <div class="table-responsive active-projects task-table">
                                                    <div class="tbl-caption">
                                                        <h4 class="heading mb-0">{t('activity')}</h4>
                                                    </div>
                                                    <table class="table table-bordered table-hover verticle-middle table-responsive-sm">
                                                        <thead class="thead-primary">
                                                            <tr>

                                                                <th>{t('title')}</th>
                                                                <th>{t('structure')}</th>
                                                                <th>{t('typology')}</th>
                                                                <th>{t('category')}</th>
                                                                <th>Codifica</th>
                                                                <th>Rev</th>
                                                                <th>Elab</th>
                                                                <th>Scadenza</th>
                                                                <th >{t('status')}</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>

                                                                <td>
                                                                    Relazione Annuale sullo stato del Sistema di AQ
                                                                </td>
                                                                <td>
                                                                    Presidio di Qualità
                                                                </td>
                                                                <td>
                                                                    Rendiconto
                                                                </td>
                                                                <td>
                                                                    Pianificazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    0
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-success">Approvato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Autovalutazione sul soddisfacimento dei requisiti di Sede
                                                                </td>
                                                                <td>
                                                                    Nucleo di Valutazione
                                                                </td>
                                                                <td>
                                                                    Matrice
                                                                </td>
                                                                <td>
                                                                    Relazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    6
                                                                </td>
                                                                <td><span>18 Ott 2023</span></td>
                                                                <td>
                                                                    <span>25 Nov 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-warning">Validato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Relazione sulle opinioni degli studenti
                                                                </td>
                                                                <td>
                                                                    Direzione Generale
                                                                </td>
                                                                <td>
                                                                    Rapporto
                                                                </td>
                                                                <td>
                                                                    Valutazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    1
                                                                </td>
                                                                <td><span>09 Feb 2023</span></td>
                                                                <td>
                                                                    <span>25 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-primary">Elaborato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Relazione annuale al bilancio
                                                                </td>
                                                                <td>
                                                                    Ufficio Scuole di Specializzazione Area Sanitaria
                                                                </td>
                                                                <td>
                                                                    Estratto
                                                                </td>
                                                                <td>
                                                                    Report
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    2
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-warning">Validato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Monitoraggio della gestione del ciclo della performance
                                                                </td>
                                                                <td>
                                                                    Ufficio Offerta Formativa dei Corsi di Studio
                                                                </td>
                                                                <td>
                                                                    Rendiconto
                                                                </td>
                                                                <td>
                                                                    Bilancio
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    6
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-success">Approvato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    PIAO- Piano Integrato di
                                                                </td>
                                                                <td>
                                                                    Manager Didattici
                                                                </td>
                                                                <td>
                                                                    Matrice
                                                                </td>
                                                                <td>
                                                                    Pianificazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    5
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-primary">Elaborato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Relazione Annuale della Performance
                                                                </td>
                                                                <td>
                                                                    Ufficio Bilanci e Rapporto di Sostenibilità
                                                                </td>
                                                                <td>
                                                                    Rapporto
                                                                </td>
                                                                <td>
                                                                    Relazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    3
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-primary">Elaborato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Relazione sui Corsi di Studio
                                                                </td>
                                                                <td>
                                                                    Ufficio Controllo di Gestione e Risk Management
                                                                </td>
                                                                <td>
                                                                    Estratto
                                                                </td>
                                                                <td>
                                                                    Pianificazione
                                                                </td>
                                                                <td>
                                                                    Valutazione
                                                                </td>
                                                                <td>
                                                                    1
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-warning">Validato</span>
                                                                </td>




                                                            </tr>

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xl-12">
                                        <div class="card">
                                            <div class="card-body p-0">
                                                <div class="table-responsive active-projects task-table">
                                                    <div class="tbl-caption">
                                                        <h4 class="heading mb-0">
                                                            Attività critiche
                                                        </h4>
                                                    </div>
                                                    <table class="table table-bordered table-hover verticle-middle table-responsive-sm">
                                                        <thead class="thead-danger">

                                                            <tr>

                                                                <th>Titolo</th>
                                                                <th>Struttura</th>
                                                                <th>Tipologia</th>
                                                                <th>Categoria</th>
                                                                <th>Codifica</th>
                                                                <th>Rev</th>
                                                                <th>Elab</th>
                                                                <th>Scadenza</th>
                                                                <th >Stato</th>


                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>

                                                                <td>
                                                                    Relazione Annuale sullo stato del Sistema di AQ
                                                                </td>
                                                                <td>
                                                                    Presidio di Qualità
                                                                </td>
                                                                <td>
                                                                    Rendiconto
                                                                </td>
                                                                <td>
                                                                    Pianificazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    0
                                                                </td>
                                                                <td><span>06 Feb 2023</span></td>
                                                                <td>
                                                                    <span>19 Feb 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-primary">Elaborato</span>
                                                                </td>




                                                            </tr>
                                                            <tr>

                                                                <td>
                                                                    Autovalutazione sul soddisfacimento dei requisiti di Sede
                                                                </td>
                                                                <td>
                                                                    Nucleo di Valutazione
                                                                </td>
                                                                <td>
                                                                    Matrice
                                                                </td>
                                                                <td>
                                                                    Relazione
                                                                </td>
                                                                <td>
                                                                    INT - Interno
                                                                </td>
                                                                <td>
                                                                    6
                                                                </td>
                                                                <td><span>18 Ott 2023</span></td>
                                                                <td>
                                                                    <span>25 Nov 2023</span>
                                                                </td>
                                                                <td>
                                                                    <span class="badge light badge-warning">Validato</span>
                                                                </td>




                                                            </tr>


                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                        <div class="tab-pane fade" id="Efficacia-tab-pane" role="tabpanel" aria-labelledby="Efficacia-tab" tabIndex="0">
                            <div class="container-fluid">
                                <div class="row row-cols-1 row-cols-md-2 g-4">
                                    <div class="col">
                                        <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa-regular fa-circle-dot"></i> Efficacia</h5>
                                                <p class="card-text">Esprime l'adeguatezza dell'output realizzato rispetto alle aspettative e necessità degli utenti (interni ed esterni) e possono essere misurati sia in termini quantitativi che qualitativi</p>

                                                <div class="accordion accordion-primary" id="accordion-one">
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="headingOne" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-controls="collapseOne" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Quantitativa</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-bs-parent="#accordion-one">
                                                            <div class="accordion-body-text">
                                                                <p>Quantità erogata:  esprime la quantità erogata di output (n. servizi prodotti) e è più accresciuta tramite iniziative di incremento dei servizi (ex. Documentazione online).</p>
                                                                <p>Quantità fruita:  esprime la quantità dei destinatari diretti degli output (n. fornitori) e può essere accresciuta tramite iniziative di allargamento del numero di beneficiari dei servizi. Il numero dei fruitori effettivi può anche essere rapportato al numero di fruitori potenziali.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="headingTwo" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-controls="collapseTwo" role="button" aria-expanded="true">
                                                            <span class="accordion-header-text">Qualitativa</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-bs-parent="#accordion-one">
                                                            <div class="accordion-body-text">
                                                                <p>Qualità erogata:  esprime la qualità erogata degli output attraverso parametri oggettivi (ex. Tempo di pagamento) secondo la prospettiva dell'amministrazione, e può essere migliorata tramite iniziative d'innalzamento e di presidio degli standard dei servizi.</p>
                                                                <p>Qualità percepita:  esprime la qualità percepita degli output, secondo la prospettiva dei fruitori (livello di soddisfazione).</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa-regular fa-circle-dot"></i> Efficienza</h5>
                                                <p class="card-text">Esprime la capacità d'utilizzare le risorse umane, economico-finanziarie, strumentali (input) in modo sostenibile e tempestivo nella realizzazione delle varie attività dell'amministrazione (output).</p>
                                                <div class="accordion accordion-primary" id="accordion-3">
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading3" data-bs-toggle="collapse" data-bs-target="#collapse3" aria-controls="collapse3" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Economica</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse3" class="collapse" aria-labelledby="heading3" data-bs-parent="#accordion-3">
                                                            <div class="accordion-body-text">
                                                                Esprime il costo (o la spesa) di gestione di un'attività e/o di erogazione di un servizio (risorse economiche/ quantità servizi o utenti serviti) e può essere incrementata attraverso iniziative di miglioramento organizzativo.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading4" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-controls="collapse4" role="button" aria-expanded="true">
                                                            <span class="accordion-header-text">Produttiva</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse4" class="collapse" aria-labelledby="heading4" data-bs-parent="#accordion-3">
                                                            <div class="accordion-body-text">
                                                                Esprime lo sforzo organizzativo per svolgere un'attività o un processo o per erogare un servizio e può essere espresso in termini di Full Time Equivalent (FTE) impiegabili (FTE/ quantità servizi) e può essere incrementata attraverso iniziative di miglioramento organizzativo.
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title">
                                                    <i class="fa-regular fa-circle-dot"></i> Stato delle risorse
                                                </h5>
                                                <p class="card-text">Quantificano e qualificano le risorse dell'amministrazione e possono essere misurate in termini sia quantitativi (n° risorse umane, n° pc) sia qualitativi (profili risorse umane, livello di aggiornamento delle infrastrutture informatiche)</p>
                                                <div class="accordion accordion-primary" id="accordion-4">
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading5" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-controls="collapse5" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Umane</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse5" class="collapse" aria-labelledby="heading5" data-bs-parent="#accordion-4">
                                                            <div class="accordion-body-text">
                                                                <p>  Quantità e distribuzione delle risorse umane per posizione; per fascia di età e categoria.fruitori effettivi può anche essere rapportato al numero di fruitori potenziali.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading6" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-controls="collapse6" role="button" aria-expanded="true">
                                                            <span class="accordion-header-text">
                                                                Economico-finanziarie
                                                            </span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse6" class="collapse" aria-labelledby="heading6" data-bs-parent="#accordion-4">
                                                            <div class="accordion-body-text">
                                                                Risorse stanziate; risorse per tipologia di finanziamento

                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading7" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-controls="collapse7" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Tangibili</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse7" class="collapse" aria-labelledby="heading7" data-bs-parent="#accordion-4">
                                                            <div class="accordion-body-text">
                                                                Valore del patrimonio disponibile; indice di indebitamento economico; indice di liquidità
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading8" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-controls="collapse8" role="button" aria-expanded="true">
                                                            <span class="accordion-header-text">
                                                                Intangibili
                                                            </span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse8" class="collapse" aria-labelledby="heading8" data-bs-parent="#accordion-4">
                                                            <div class="accordion-body-text">
                                                                <p>Salute organizzativa:  livello di benessere organizzativo.</p>
                                                                <p>Salute professionale:  quantità di persone laureate/ formate/ aggiornate; % profili professionali presenti rispetto alle necessità dei vari ruoli organizzativi.</p>
                                                                <p>
                                                                    Salute di genere:  rapporto donne/uomini; % di donne presenti in ruoli apicali.
                                                                </p>
                                                                <p>

                                                                    Salute relazionale:  quantità/tipologia di utenti coinvolti nel processo di programmazione o valutazione.
                                                                </p>
                                                                <p>
                                                                    Salute etica:  quantità di processi oggetto di valutazione del rischio.
                                                                </p>
                                                                <p>
                                                                    Salute digitale:  % servizi digitalizzati.
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="card">
                                            <div class="card-body">
                                                <h5 class="card-title"><i class="fa-regular fa-circle-dot"></i> Impatto</h5>
                                                <p class="card-text">Esprime l'effetto atteso o generato (outcome) da una politica o da un servizio sui destinatari diretti o indiretti, nel medio-lungo termine.</p>
                                                <div class="accordion accordion-primary" id="accordion-5">
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading11" data-bs-toggle="collapse" data-bs-target="#collapse11" aria-controls="collapse11" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Sociale</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse11" class="collapse" aria-labelledby="heading8" data-bs-parent="#accordion-5">
                                                            <div class="accordion-body-text">
                                                                L'impatto indotto sulle varie componenti della società e sulle relative condizioni sociali.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading9" data-bs-toggle="collapse" data-bs-target="#collapse9" aria-controls="collapse9" role="button" aria-expanded="true">
                                                            <span class="accordion-header-text">
                                                                Economico
                                                            </span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse9" class="collapse" aria-labelledby="heading9" data-bs-parent="#accordion-5">
                                                            <div class="accordion-body-text">
                                                                L'impatto indotto sulle varie componenti della società del tessuto economico.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="accordion-item">
                                                        <div class="accordion-header collapsed rounded-lg" id="heading10" data-bs-toggle="collapse" data-bs-target="#collapse10" aria-controls="collapse10" aria-expanded="true" role="button">
                                                            <span class="accordion-header-icon"></span>
                                                            <span class="accordion-header-text">Ambientale</span>
                                                            <span class="accordion-header-indicator"></span>
                                                        </div>
                                                        <div id="collapse10" class="collapse" aria-labelledby="heading10" data-bs-parent="#accordion-5">
                                                            <div class="accordion-body-text">
                                                                L'impatto indotto sulle varie componenti del contesto geo-morfologico in cui opera l'Ateneo
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>




            </>
        )

    }

    return (
        <>
            {process.env.REACT_APP_PROFILE?.toLowerCase() === "darm"
                ? darmDashboard()
                : aiplanNewDashboard()
            }
        </>
    );




}


export { Dashboard_Screen }